export const STATUS_DICTIONARY = {
  need_payment: {
    color: "#FFC521",
    label: "در انتظار پرداخت",
  },
  pending: {
    color: "#FFC521",
    label: "نیاز به بررسی",
  },
  processing: {
    color: "#FFC521",
    label: "در حال پردازش",
  },
  sending: {
    color: "#FFC521",
    label: "در حال ارسال",
  },
  delivery_pending: {
    color: "#FFC521",
    label: "در انتظار ارسال",
  },
  canceled: {
    color: "#FF3C3C",
    label: "لغو شده",
  },
  completed: {
    color: "#28a745",
    label: "تکمیل شده",
  },
  accepted: {
    color: "#28a745",
    label: "تایید شده",
  },
  refunded: {
    color: "#FF3C3C",
    label: "مسترد شده",
  },
  failed: {
    color: "#FF3C3C",
    label: "ناموفق",
  },
  success: {
    color: "#28a745",
    label: "موفق",
  },
  temp: {
    color: "grey",
    label: "در انتظار پرداخت",
  },
};

export const ALOPEYK_STATUS_DICTIONARY = {
  new: {
    color: "#FFC521",
    label: "در انتظار پرداخت",
  },
  searching: {
    color: "#FFC521",
    label: "نیاز به بررسی",
  },
  picking: {
    color: "#FFC521",
    label: "در حال پردازش",
  },
  accepted: {
    color: "#FFC521",
    label: "در حال ارسال",
  },
  delivering: {
    color: "#FFC521",
    label: "در انتظار ارسال",
  },
  cancelled: {
    color: "#FF3C3C",
    label: "لغو شده",
  },
  finished: {
    color: "#28a745",
    label: "تکمیل شده",
  },
  expired: {
    color: "#FF3C3C",
    label: "مسترد شده",
  },
  delivered: {
    color: "#28a745",
    label: "موفق",
  },
  scheduled: {
    color: "grey",
    label: "در انتظار پرداخت",
  },
};

export const REASON_DICTIONARY = {
  wallet: "کیف پول",
  order: "سفارش",
};

export const fieldsTranslation = {
  id: "شناسه",
  payment_authority: "کد پیگیری",
  payment_ref_id: "شماره ارجاع",
  child_count: "تعداد زیرمجموعه",
  product_count: "تعداد محصول",
  category_image_url: "تصویر دسته‌بندی",
  parent_name: "نام والد",
  private_metadata: "اطلاعات خصوصی",
  metadata: "اطلاعات",
  seo_title: "عنوان سئو",
  seo_description: "توضیحات سئو",
  name: "نام",
  slug: "اسلاگ",
  created_date: "تاریخ ایجاد",
  modified_date: "تاریخ آخرین تغییر",
  description: "توضیحات",
  short_description: "توضیح کوتاه",
  display_priority: "اولویت نمایش",
  parent: "والد",
  image: "تصویر",
  group: "گروه",
  address: "آدرس",
  full_name: "نام کامل",
  last_order: "آخرین سفارش",
  b2b_status: "وضعیت B2B",
  wallet_balance: "موجودی کیف پول",
  can_submit_b2b_order: "امکان ثبت سفارش B2B",
  next_visit_tour_day: "روز بازدید بعدی",
  password: "رمز عبور",
  last_login: "آخرین ورود",
  first_name: "نام",
  last_name: "نام خانوادگی",
  email: "ایمیل",
  is_active: "فعال",
  date_joined: "تاریخ عضویت",
  username: "نام کاربری",
  phone_number: "شماره تلفن",
  role: "نقش",
  birthday_date: "تاریخ تولد",
  national_code: "کد ملی",
  online_payment: "پرداخت آنلاین",
  offline_payment: "پرداخت آفلاین",
  wallet_payment: "پرداخت از کیف پول",
  in_location_payment: "پرداخت در محل",
  score: "امتیاز",
  default_address: "آدرس پیش‌فرض",
  region: "منطقه",
  user_permissions: "دسترسی‌های کاربر",
  channel: "کانال",
  segment: "سگمنت",
  vendor: "فروشنده",
  status: "وضعیت",
  owner_name: "نام صاحب",
  owner_national_code: "کد ملی صاحب",
  latitude: "عرض جغرافیایی",
  longitude: "طول جغرافیایی",
  order_item: "آیتم سفارش",
  total_item: "کل آیتم‌ها",
  remaining_time: "زمان باقی‌مانده",
  shipping_cost: "هزینه ارسال",
  delivery_code: "کد تحویل",
  user: "کاربر",
  payment: "پرداخت",
  shipping_address: "آدرس تحویل",
  shipping_time: "زمان ارسال",
  rider: "پیک",
  online_transaction: "تراکنش آنلاین",
  wallet_transaction: "تراکنش کیف پول",
  offline_transaction: "تراکنش آفلاین",
  payment_method: "روش پرداخت",
  reason: "دلیل",
  amount: "مبلغ",
  callback: "کال‌بک",
  type: "نوع",
  code: "کد",
  is_used: "استفاده شده",
  has_free_shipping: "ارسال رایگان",
  usage_limit: "حداکثر استفاده",
  usage_limit_per_user: "حداکثر استفاده برای هر کاربر",
  minimum_amount: "حداقل مبلغ",
  maximum_amount: "حداکثر مبلغ",
  start_date: "تاریخ شروع",
  expire_date: "تاریخ انقضا",
  excluded_product: "محصولات حذف شده",
  included_product: "محصولات شامل",
  excluded_category: "دسته‌بندی‌های حذف شده",
  included_category: "دسته‌بندی‌های شامل",
  start_at: "شروع در",
  end_at: "پایان در",
  shine_offer: "پیشنهاد شاین",
  vendor_offer: "پیشنهاد فروشگاه",
  brand: "برند",
  category: "دسته‌بندی",
  vendor_product: "محصول فروشگاه",
  customer_name: "نام مشتری",
  total_amount: "مبلغ کل",
  total_tax_amount: "مبلغ مالیات",
  total_discount_amount: "مبلغ تخفیف",
  owner_phone_number: "شماره همراه",
  payed_price: "مبلغ پرداخت‌شده",
  subtotal_amount: "جمع جز سفارش",
  discount_amount: "مبلغ تخفیف",
  total_amount_after_discount: "مبلغ کل بعد از اعمال تخفیف",
  discount: "تخفیف",
};
